import { useState, useEffect } from "react";
import { CompoundInterestInputCard } from "./components/CompoundInterestInputCard";
import { CompoundInterestResponse } from "./components/CompoundInterestResponse";

export default function JurosCompostos() {
  const [results, setResults] = useState<ResultsType | null>(null);

  useEffect(() => {
    const metaTag = document.createElement('meta');
    metaTag.name = 'robots';
    metaTag.content = 'noindex, nofollow';
    document.head.appendChild(metaTag);

    return () => {
      const existingTag = document.querySelector('meta[name="robots"][content="noindex, nofollow"]');
      if (existingTag) {
        document.head.removeChild(existingTag);
      }
    };
  }, []);

  return (
    <>
      <CompoundInterestInputCard setResults={setResults} />
      {results && <CompoundInterestResponse results={results} />}
    </>
  );
}